import * as React from "react";
import { PageContainer } from "../../../components";
import { DrupalBabyDogList } from "./DrupalBabyDogList";
import { DrupalBreedSearchBar } from "../breed/DrupalBreedSearchBar";

export interface IDrupalBabyDogListPageProps {}

export const DrupalBabyDogListPage: React.FunctionComponent<IDrupalBabyDogListPageProps> = () => {
  const [breedId, setbreedId] = React.useState<number>(null);
  return (
    <PageContainer>
      <DrupalBreedSearchBar onSelectionChanged={(b: number) => setbreedId(b)} />
      <DrupalBabyDogList breedId={breedId} />
    </PageContainer>
  );
};
